import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class XataEditPage extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    externalDatabase: '',
    collectionsByAppwrite: [],
    collectionsByexternaldb: [],
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    const { dbUuid, projectId, version } = match.params;
    await actions.loadExternalDatabaseForXata({ projectId, version, dbUuid });
    await actions.collectionListExternaldbs({ projectId, dbUuid, version });
    const { collectionList, externalDatabaseXata } = this.props.dataConnector;
    this.setState({ externalDatabase: externalDatabaseXata });
    this.setState({ collectionsByexternaldb: collectionList });
  }

  handleCreateCollection = async (item) => {
    const { match, history, actions } = this.props;
    const { dbUuid, projectId, version } = match.params;
    const { externalDatabase } = this.state;
    const { setting, completeData } = externalDatabase;
    const { database } = completeData;
    const { workspaceId, name, region } = database;
    const dataForRequest = {
      projectId,
      version,
      tableName: item.name,
      workspaceId,
      region,
      databaseName: name,
      headers: setting,
      branchName: item.branch ? item.branch : '',
    };
    await actions.getSchemaForXataCollection(dataForRequest);
    if (this.props.dataConnector.schemaForXata) {
      const { schemaForXata } = this.props.dataConnector;
      const fields = schemaForXata.reduce((obj, item) => {
        obj[item.name] = item.type;
        return obj;
      }, {});
      const dataForUpdate = {
        projectId,
        version,
        tableName: item.name,
        dbUuid,
        fields: fields,
        branch: item.branch ? item.branch : '',
      };
      await actions.updateTableAndFieldsForXata(dataForUpdate);
      this.props.history.push(
        `/data-connector/${version}/v/${projectId}/xata/${dbUuid}/${item.name}`,
      );
    }
  };
  handleUpdateCollection = async (item) => {
    const { match, history, actions } = this.props;
    const { projectId, dbUuid, version } = match.params;
    const { externalDatabase } = this.state;
    const { setting, completeData } = externalDatabase;
    const { database } = completeData;
    const { workspaceId, name, region } = database;
    const dataForRequest = {
      projectId,
      version,
      tableName: item.name,
      workspaceId,
      region,
      databaseName: name,
      headers: setting,
      branchName: item.branch ? item.branch : '',
    };
    await actions.getSchemaForXataCollection(dataForRequest);
    if (this.props.dataConnector.schemaForXata) {
      const { schemaForXata } = this.props.dataConnector;
      const fields = schemaForXata.reduce((obj, item) => {
        obj[item.name] = item.type;
        return obj;
      }, {});
      const dataForUpdate = {
        projectId,
        version,
        tableName: item.name,
        dbUuid,
        fields: fields,
        branch: item.branch ? item.branch : '',
      };
      await actions.updateTableAndFieldsForXata(dataForUpdate);
      this.props.history.push(
        `/data-connector/${version}/v/${projectId}/xata/${dbUuid}/${item.name}/update`,
      );
    }
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const {
      loadExternalDatabaseForXataPending,
      collectionListExternaldbsPending,
      getSchemaForXataCollectionPending,
    } = this.props.dataConnector;
    if (loadExternalDatabaseForXataPending || collectionListExternaldbsPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={loadExternalDatabaseForXataPending || collectionListExternaldbsPending}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    const { externalDatabase, collectionsByexternaldb } = this.state;
    const tables = externalDatabase ? externalDatabase.completeData.tables : null;
    const collectionsWithDb = collectionsByexternaldb.map((a) => a.collectionTitle);

    return (
      tables && (
        <CommonPageComponent>
          <ParentContentCard title={'All Collections in Xata Database'} icon={'collection'}>
            <div className="grid__column">
              {tables.map((item, index) => (
                <span
                  className={`card card--user-profile ml-4 card--collection-source`}
                  key={index}
                >
                  <div className="card-body">
                    <div className="avatar__meta">
                      <h5 className="avatar__title js-user-name" title={item.name}>
                        {item.name}
                      </h5>
                      {collectionsWithDb.includes(item.name) ? (
                        <button
                          className="btn btn-theme-submit btn-md"
                          onClick={() => this.handleUpdateCollection(item)}
                          disabled={getSchemaForXataCollectionPending}
                        >
                          <i className="wb webconnect-save-regular"> </i>
                          &nbsp;Update
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary btn-md"
                          onClick={() => this.handleCreateCollection(item)}
                          disabled={getSchemaForXataCollectionPending}
                        >
                          <i className="wb webconnect-plus"> </i>
                          &nbsp;Create
                        </button>
                      )}
                    </div>
                  </div>
                </span>
              ))}
            </div>
          </ParentContentCard>
        </CommonPageComponent>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XataEditPage);
